import React, { useEffect } from "react";
import Layout from "../../Layout";
import DialerAIContainer from "../../containers/DialerAI";
import { Helmet } from "react-helmet";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";

export default function DialerAIPage() {
  const captureEvent = useCaptureEvent();

  useEffect(() => {
    captureEvent("SET_DialerAI_PageView");
  }, [captureEvent]);

  return (
    <Layout>
      <Helmet>
        <title>Dialer & AI Settings - {process.env.REACT_APP_APP_NAME}</title>
      </Helmet>
      <DialerAIContainer />
    </Layout>
  );
}

